import { Flex, VStack, StackProps, FlexProps } from '@chakra-ui/react';

type CenterLoaderProps = {
  children: React.ReactNode;
  overlayProps?: StackProps;
  wrapperProps?: FlexProps;
};

const CenterLoader = ({ children, overlayProps, wrapperProps }: CenterLoaderProps) => (
  <VStack
    {...overlayProps}
    sx={{
      zIndex: 2,
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bgColor: 'rgba(0, 0, 0, 0.5)',
      ...overlayProps?.sx,
    }}
  >
    <Flex
      {...wrapperProps}
      sx={{
        flexDir: 'column',
        minHeight: 120,
        minWidth: 200,
        padding: 10,
        justifyContent: 'space-evenly',
        alignItems: 'center',
        borderRadius: 5,
        bgColor: 'white',
        margin: 'auto',
        ...wrapperProps?.sx,
      }}
    >
      {children}
    </Flex>
  </VStack>
);
export default CenterLoader;
